import React, { Fragment } from 'react';
import CustomInfiniteScroll from "../../../../../Shared/components/CustomInfiniteScroll";
import { deliveryCustomerDetails } from "../../../../../../config/constant";
import { Checkbox, TableCell, TableRow } from '@mui/material';
import SearchText from '../../../../../Shared/components/SearchText';
import { checkComponentPermission, getColumnWidth } from "../../../../../../helpers/utilities";
import moment from 'moment';
import { NavLink } from "react-router-dom"
import PrintIcon from "../../../../../../assets/images/icon_actions/Print.svg";
import { Image } from "antd";


export const CustomerDetails = (props) => {
    const { onRequestSort, sortOrder, sortBy, details, handlePrint,
        loadMore, loadMoreContent, loadMoreTask, roleManagement, clsx, classes, search, selected, handleClick, handleSelected } = props;

    const isSelected = (name) => selected?.indexOf(name) !== -1;

    return (
        <CustomInfiniteScroll
            loadMore={loadMore}
            loadMoreContent={loadMoreContent}
            heads={deliveryCustomerDetails}
            onRequestSort={(sortBy, sortOrder) => onRequestSort(sortBy, sortOrder)}
            sortOrder={sortOrder}
            width={true}
            details={details}
            sortBy={sortBy}
            selected={selected}
            onSelected={(value) => handleSelected(value)}
            loadMoreTask={() => loadMoreTask()}
            component={
                <>
                    {
                        loadMore ? (
                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell className={classes.textAlignCenter} colSpan={deliveryCustomerDetails?.length}><div className={classes.loadMoreCircle}></div></TableCell>
                            </TableRow>
                        ) : (
                            <Fragment>
                                {
                                    details && Array.isArray(details) && details?.length > 0 ? details?.map((data, i) => (
                                        <TableRow key={i} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell className={clsx('checkbox', classes.tablealign)}
                                                onClick={(e) => handleClick(data.id)}
                                                padding="checkbox"><Checkbox color="primary"
                                                    checked={isSelected(data.id)} /></TableCell>
                                            <TableCell style={{ width: getColumnWidth(deliveryCustomerDetails, 1) }}><span style={{ width: getColumnWidth(deliveryCustomerDetails, 1) }}>{data?.customerName || '---'}</span></TableCell>
                                            <TableCell style={{ width: getColumnWidth(deliveryCustomerDetails, 2) }}><span style={{ width: getColumnWidth(deliveryCustomerDetails, 2) }}>{data?.customer?.serialNo || '---'}</span></TableCell>
                                            <TableCell style={{ width: getColumnWidth(deliveryCustomerDetails, 3) }}><span style={{ width: getColumnWidth(deliveryCustomerDetails, 3) }}>{data?.serialNo || '---'}</span></TableCell>
                                            <TableCell style={{ width: getColumnWidth(deliveryCustomerDetails, 4) }}><span style={{ width: getColumnWidth(deliveryCustomerDetails, 4) }}>{moment(data.invoiceDate).format('DD MMM YYYY')}</span></TableCell>
                                            <TableCell style={{ width: getColumnWidth(deliveryCustomerDetails, 4) }}><span style={{ width: getColumnWidth(deliveryCustomerDetails, 4) }}>{data?.selfBill?.serialNo || '---'}</span></TableCell>
                                            <TableCell style={{ width: getColumnWidth(deliveryCustomerDetails, 5) }}><span style={{ width: getColumnWidth(deliveryCustomerDetails, 5) }}>
                                                {
                                                    data?.salesInvoiceItems ? data?.salesInvoiceItems.reduce((a, v) => a = a + v.quantity, 0) : 0
                                                }
                                            </span></TableCell>
                                            <TableCell style={{ width: getColumnWidth(deliveryCustomerDetails, 6) }}><span style={{ width: getColumnWidth(deliveryCustomerDetails, 6) }}>{data?.pincode?.code || '---'}</span></TableCell>
                                            <TableCell style={{ width: getColumnWidth(deliveryCustomerDetails, 7) }}><span style={{ width: getColumnWidth(deliveryCustomerDetails, 7) }}>{data?.state?.name || '---'}</span></TableCell>
                                            <TableCell>
                                                {
                                                    roleManagement !== '' && checkComponentPermission('Delivery Details', 'Action', 'Print') &&
                                                    <NavLink to={`#`} onClick={() => handlePrint('single', data.id)}>
                                                        <Image
                                                            src={PrintIcon}
                                                            preview={false}
                                                        />
                                                    </NavLink>
                                                }
                                            </TableCell>
                                        </TableRow>
                                    )) : (
                                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell className={classes.textAlignCenter} colSpan={deliveryCustomerDetails.length}>
                                                {
                                                    search ? <SearchText /> : <p className={clsx(classes.noResultsText, classes.textAlignCenter)}>
                                                        This space will display all query once you start creating it
                                                    </p>
                                                }
                                            </TableCell>
                                        </TableRow>
                                    )
                                }
                            </Fragment>
                        )
                    }
                </>
            }
        />
    )
}